/* eslint-disable max-len */
import {
  MOBILE_2L_BREAKPOINT,
  MOBILE_3L_BREAKPOINT,
  MOBILE_4L_BREAKPOINT,
  MOBILE_L_BREAKPOINT,
  MOBILE_M_BREAKPOINT,
  TABLET_BREAKPOINT,
} from '@constant/system';
import {ACTION_BUTTON_Z_INDEX} from '.';

// eslint-disable-next-line arrow-body-style
const desktop = theme => {
  return {
    cardContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '155px',
      textAlign: 'center',
      alignItems: 'center',
    },
    scrollableIndicator: {
      display: 'none',
    },
    cardsAndAmountContainer: {
      maxWidth: 'unset',
    },
    actionButton: {
      // width: '9.5vw',
      height: 40,
      width: '100%',
    },
    buttonsRowScrollableContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '72%',
      float: 'right',
      margin: [0, 10, 20, 10],
    },
    buttonsRowScrollableLongDiv: {},
    buttonsRowAllinScrollable: {
      alignItems: 'center',
      flexFlow: 'unset',
      flexWrap: 'nowrap',
      '& button:nth-child(1)': {
        margin: 'none',
      },
    },
    buttonsRowScrollable: {
      alignItems: 'center',
      flexWrap: 'wrap',
      flexFlow: 'unset',
      '& button:nth-child(1)': {
        margin: 'none',
      },
    },
    persistentActionButton: {
      width: '48%',
    },
    sliderRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      '& .ant-form-item': {
        margin: '0px',
        width: '220px',
      },
      '& .ant-slider-disabled': {
        visibility: 'hidden',
      },
    },
    firstButtonRow: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    secondButtonRow: {extend: 'firstButtonRow', marginRight: '5px'},
    shortcutButton: {
      width: 'calc(25% - 5px)',
      border: 'none',
      borderRadius: '3px',
      margin: '0 0 0 5px',
      '&Container': {
        width: '80%',
        marginLeft: 0,
        marginBottom: '10px',
        flexWrap: 'wrap',
        flexDirection: 'row-reverse',
      },
      '&Wrap': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: 'inherit',
        flexGrow: 1,
        marginTop: '0px',
        zIndex: 1,
      },
      '&Column': {
        alignItems: 'center',
        fontSize: 'clamp(10px, 0.5vw, 15px)',
      },
      '&Text': {
        fontSize: 'clamp(10px, 0.5vw, 15px)',
      },
      '&Tag': {
        height: '14px',
        clipPath: 'unset',
        background: 'none',
      },
      '&BB': {
        fontSize: 'clamp(10px, 0.7vw, 15px)',
        fontWeight: 600,
        lineHeight: '20px',
      },
    },
    inputAreaWrap: {
      height: '40px',
      width: '20%',
      marginRight: '10px',
      '& .ant-input-number': {
        '&:hover, &:focus, &:active, &[disabled]': {borderColor: 'white !important'},
      },
      '& .ant-input-number-focused': {
        borderColor: 'white !important',
      },
      marginLeft: '5px',
      marginBottom: '10px',
      '& .ant-input-number-disabled': {
        visibility: 'hidden',
      },
      '& .ant-form-item': {
        margin: '0px',
      },
    },
    inputArea: {
      display: 'flex',
      alignItems: 'center',
      height: '40px',
      fontSize: 14,
      color: 'white',
      marginBottom: '5px',
      width: '100%',
      background: ' rgba(0, 0, 0, 0.25)',
      border: '2px solid rgba(255, 255, 255, 0.5)',
      borderRadius: '10px',
      '& .ant-input-number-group-addon': {
        background: 'transparent',
        color: 'white',
        border: 'none',
        padding: '0 6px',
      },
      '& .ant-input-number-in-form-item': {
        border: 'none',
        background: 'transparent',
      },
      '& .ant-input-number-input-wrap': {
        height: '100%',
      },
      '& .ant-input-number-handler': {
        borderLeft: '1px solid rgba(255, 255, 255, 0.5)',
      },
      '& >.ant-input-number-handler-wrap': {
        background: 'black',
        display: 'none',
        '& .ant-input-number-handler:hover': {
          '& .ant-input-number-handler-up-inner,.ant-input-number-handler-down-inner': {
            color: 'white',
          },
        },
      },
      '& .ant-input-number-input': {
        height: '100%',
        textAlign: 'right',
        color: 'white',
      },
    },
    inputAreaBB: {
      extend: 'inputArea',
      border: '2px solid red',
    },
    inputAreaWithWaring: {
      extend: 'inputArea',
      color: 'red',
    },
    sliderWrap: {
      position: 'relative',
      display: 'flex',
    },
    desktopSlider: {
      // width: '50%',
      position: 'relative',
      width: '220px',
      height: 30,
      margin: '10px 30px 15px 6px',
      '&.ant-slider': {
        '&:hover .ant-slider-rail': {
          backgroundColor: 'transparent',
        },
      },
      '&:hover .ant-slider-handle:not(.ant-tooltip-open)': {
        borderColor: '#d1b255',
      },
      '& .ant-slider-rail': {
        border: ' 2px solid #d1b255',
        height: 30,
        borderRadius: 10,
        background:
          // eslint-disable-next-line max-len
          ' linear-gradient(180deg, rgba(255, 199, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 16.67%, rgba(9, 9, 9, 0.25) 33.33%, rgba(0, 0, 0, 0.25) 50%, rgba(0, 0, 0, 0.25) 66.67%, rgba(0, 0, 0, 0.25) 83.33%, rgba(0, 0, 0, 0.25) 100%)',
        boxShadow: '0px 0px 5px #000000, inset 0px 0px 10px #000000',
        backdropFilter: 'blur(10px)',
      },
      '& .ant-slider-handle': {
        width: 25,
        height: 40,
        background:
          // eslint-disable-next-line max-len
          'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(352.35deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        boxShadow: ' 0px 0px 5px #ffffff',
        borderRadius: '10px',
        border: '2px solid #d1b255',
        top: 0,
      },
      '& .ant-slider-track': {
        background: 'transparent !important',
        // background: 'linear-gradient(rgb(255, 215, 46), rgb(232, 166, 60), rgb(196, 100, 40))',
        height: 30,
        borderRadius: 10,
      },
      '& .ant-slider-step': {
        display: 'none',
      },
    },
    sameMinMaxTriggered: {
      '& .ant-slider-handle': {
        left: '100%',
      },
    },
    buttonText: {
      writingMode: ' vertical-rl',
      textOrientation: 'mixed',
      display: 'inline-block',
      fontSize: '16px',
      fontWeight: 600,
      fontFamily: 'PingFang HK',
      position: 'relative',
      '&:before': {
        content: 'attr(data-text)',
        background: 'linear-gradient(to bottom,#261603 0%, #6E4D21 100%)',
        '-webkit-text-stroke': '2px transparent',
        '-webkit-background-clip': 'text',
      },
      '&:after': {
        content: 'attr(data-text)',
        top: 0,
        position: 'absolute',
        backgroundImage:
          'linear-gradient(180deg, #FFFAC8 20%, #BC954F 61.08%, #E4C46F 69.24%, #E9C35D 78%)',
        ' -webkit-background-clip': 'text',
        color: 'transparent',
      },
    },
    allInDiv: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'absolute',
      bottom: 5,
      right: '4px',
      zIndex: 1,
      width: 'fit-content',
      height: 'fit-content',
    },
    placeBetButton: {
      margin: '0 5px',
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  const buttonMargin = 15;
  const shortcutButtonBg = 'linear-gradient(#4A4A4A, #151515)';
  const actionButtonBg =
    // eslint-disable-next-line max-len
    'linear-gradient(0deg, rgba(102, 102, 102, 0.5), rgba(102, 102, 102, 0.5)), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)';
  const actionButtonHeight = 40;
  const scrollIndicatorGradient = 'rgb(34 34 34 / 20%), rgb(34 34 34) 30% 100%';

  return {
    cardsAndAmountContainer: {
      position: 'relative',
      width: 'fit-content',
      marginLeft: buttonMargin,
      maxWidth: 120,
      height: '100%',
      justifyContent: 'flex-end',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    allInAnimationContainer: {
      // width: '100vw',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      width: '100%',
      height: 'auto',
      opacity: 1,
    },
    [`@media only screen and (max-width: ${TABLET_BREAKPOINT}px)`]: {
      allInAnimationContainer: {
        top: '-550px',
      },
    },
    [`@media only screen and (max-width: ${MOBILE_4L_BREAKPOINT}px)`]: {
      allInAnimationContainer: {
        top: '-430px',
      },
    },
    [`@media only screen and (max-width: ${MOBILE_3L_BREAKPOINT}px)`]: {
      allInAnimationContainer: {
        top: '-240px',
      },
    },
    [`@media only screen and (max-width: ${MOBILE_2L_BREAKPOINT}px)`]: {
      allInAnimationContainer: {
        top: '-140px',
      },
    },
    [`@media only screen and (max-width: ${MOBILE_L_BREAKPOINT}px)`]: {
      allInAnimationContainer: {
        top: '-70px',
      },
    },
    [`@media only screen and (max-width: ${MOBILE_M_BREAKPOINT}px)`]: {
      allInAnimationContainer: {
        top: '0px',
      },
    },
    callAnimationContainer: {
      position: 'absolute',
      margin: 'auto',
    },
    allInAnimation: {
      width: '100%',
    },
    myPokerCard: {
      flexShrink: 1,
      display: 'block',
    },
    myCards: {
      display: 'flex',
      flexWrap: 'nowrap',
      maxWidth: '100%',
    },
    omahaCardList: {
      transform: 'translateX(-4px)',
    },
    cardField: {
      position: 'relative',
    },
    amountAndDecision: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '120px',
      minHeight: '30px',
      position: 'relative',
      textAlign: 'center',
      background: '#2C2C31',
      borderRadius: '10px 10px 0px 0px',
      opacity: '0.95',
      padding: '4px 0px',
    },
    myDecision: {
      fontSize: 16,
      lineHeight: '16px',
      color: theme.betTextColor,
    },
    playerName: {
      textAlign: 'center',
      letterSpacing: '0px',
      width: '120px',
      height: '20px',
      color: '#DBDBDB',
      background: '#4F4F58',
      boxShadow: '0px 3px 4px #000000CB',
      borderRadius: ' 0px 0px 5px 5px',
      opacity: 0.9,
      fontSize: '12px',
      textOverflow: 'ellipsis',
      overflowX: 'hidden',
    },
    minusButton: {
      display: 'none',
      position: 'absolute',
      zIndex: 15,
      fontSize: '18px',
      bottom: '380%',
      right: '-40%',
      width: '35px',
      height: '35px',
      background: '#4F4F58',
      color: '#FFFFFF',
      border: 'none',
      '&.ant-btn:hover': {
        color: theme.textColor,
        background: `${actionButtonBg}`,
      },
    },
    plusButton: {
      extend: 'minusButton',
      bottom: '500%',
    },
    myBestCombination: {
      background: 'radial-gradient(#6E6DFE, #6E6DFE4A, #1F002933)',
      color: theme.textColor,
      fontSize: 14,
      width: '25vw',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    raiseBetButtonContainer: {
      display: 'flex',
      '& .ant-btn': {
        background: '#4f4f4f',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px 0px 5px rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(8.5px)',
        width: 30,
        height: 30,
        padding: 0,
        margin: '2.5px',
        border: 'none',
        borderRadius: '6px',
        '&[disabled]': {
          visibility: 'hidden',
        },
      },
    },
    betOrRaiseButton: {
      color: theme.textColor,
      width: 38,
      height: 35,
      border: 'none',
      background: 'rgb(11 11 11 / 81%)',
      boxShadow: '0px 3px 6px #000000A6',
      opacity: ' 0.83',
      backdropFilter: ' blur(17px)',
      '-webkit-backdrop-filter': 'blur(17px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&[disabled]': {
        background: 'inherit',
        opacity: 0.3,
      },
    },
    keyboardOrNumpadButton: {
      margin: 2.5,
      width: 30,
      height: 30,
      background: 'rgba(0, 0, 0, 0.2)',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px 0px 5px rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(8.5px)',
      borderRadius: 6,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&.ant-btn': {
        padding: 0,
        border: 'none',
        '&:hover, &:focus, &:active, &[disabled]': {
          border: 'none',
          background: 'rgba(0, 0, 0, 0.2)',
        },
      },
      // TODO window resize, it will turn white
      '&[disabled]': {
        background: 'inherit',
        opacity: 0.3,
      },
    },
    buttonContent: {
      margin: 'auto',
      width: 26,
      height: 26,
      background: '#4f4f4f',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      backdropFilter: 'blur(8.5px)',
      borderRadius: 4,
      '&.isClicked': {
        background: 'transparent',
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    keyboardIcon: {
      width: '100%',
    },
    sliderIcon: {
      width: '70%',
    },
    betRaiseButtonArrow: {
      width: 28,
    },
    sliderColumn: {
      zIndex: 1,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
    },
    '@keyframes sliderSlideUp': {
      '0%': {
        transform: 'translate(0%, 100%) scaleY(0.1)',
      },
      '100%': {
        transform: 'translate(0%, 0%) scaleY(1)',
      },
    },
    '@keyframes bounceUp': {
      '0%': {
        transform: 'translate(-50%, 100%)',
        // * opacity would affect blur, please avoid
        // opacity: 0,
      },
      '60%': {
        transform: 'translate(-50%, -5px)',
      },
      '80%': {
        transform: 'translate(-50%, 5px)',
      },
      '100%': {
        transform: 'translate(-50%, 0)',
      },
    },
    sliderSlideUpAnimation: {
      animation: '$sliderSlideUp 1s ease-out forwards',
    },
    sliderColumnWithNumPadOpen: {
      extend: 'sliderColumn',
      justifyContent: 'flex-end',
    },
    customizedSwitch: {
      '&.ant-switch': {
        width: '60px',
        height: '30px',
        background: 'rgba(0, 0, 0, 0.2)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px 0px 5px rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(8.5px)',
        borderRadius: '6px',
      },
      '&.ant-switch-checked': {
        '& .ant-switch-handle:before': {
          left: -8,
          content: 'url(/images-mobile/game-room/ActionButtons/grey-upper-arrow.svg)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
      '& .ant-switch-handle': {
        '&:before': {
          background: '#FFFFFF',
          opacity: '0.2',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
          backdropFilter: 'blur(8.5px)',
          borderRadius: 4,
          width: 26,
          height: 26,
          content: 'url(/images-mobile/game-room/ActionButtons/grey-keyboard-icon.svg)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
    buttonsColumn: {
      paddingBottom: 24, // Safety area bottom
    },
    actionButton: {
      boxShadow: ' 0px 5px 10px rgba(0, 0, 0, 0.25)',
      borderRadius: 3,
      padding: [0, 5],
      border: 'none',
      height: actionButtonHeight,
      color: theme.textColor,
      width: '100%',
      margin: [0, 5],
      fontSize: 14,
      background: actionButtonBg,
      textTransform: 'uppercase',
      '&.ant-btn:hover': {
        //! otherwise it remains white on mobile
        color: theme.textColor,
        background: `${actionButtonBg}`,
      },
      //! when btn is pressed
      '&.ant-btn:active': {
        // background:
        //   'linear-gradient(0deg, rgba(141, 76, 171, 0.25), rgba(141, 76, 171, 0.25)), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        // color: theme.textColor,
      },
      '&.ant-btn[disabled]': {
        color: theme.textColor,
        background:
          'linear-gradient(360deg, rgba(102, 102, 102, 0.5), rgba(102, 102, 102, 0.5)), linear-gradient(0deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        filter: 'brightness(0.5)',
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, rgba(141, 76, 171, 0.25), rgba(141, 76, 171, 0.25)), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
        // TODO cant select .buttonLabel, so div is selected
        '& > div': {
          borderColor: '#AB79BA',
        },
      },
    },
    scrollableIndicator: {
      position: 'fixed',
      color: theme.textColor,
      zIndex: ACTION_BUTTON_Z_INDEX.SCROLLABLE_INDICATOR,
      display: 'flex',
      alignItems: 'center',
      height: actionButtonHeight,
      width: 16,
    },
    scrollableIndicatorLeft: {
      extend: 'scrollableIndicator',
      background: `linear-gradient(to left, ${scrollIndicatorGradient})`,
      left: 0,
    },
    scrollableIndicatorRight: {
      extend: 'scrollableIndicator',
      background: `linear-gradient(to right, ${scrollIndicatorGradient})`,
      right: 0,
      justifyContent: 'flex-end',
    },
    placeBetButton: {
      padding: 0,
      extend: 'actionButton',
      margin: 10,
      textTransform: 'none',
      zIndex: 3,
      fontSize: '20px',
      '& > span': {
        boxShadow: '2px 2px 4px ##9AD0FF',
      },
      '&.ant-btn[disabled], &.ant-btn[disabled]:hover': {
        display: 'none',
      },
    },
    callButtonDiv: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginInlineEnd: 0,
    },
    buttonLabel: {
      margin: '2px',
      borderLeft: '4px solid #0C1015',
      borderRight: ' 4px solid #0C1015',
      height: 'calc(100% - 4px)',
      width: 'calc(100% - 4px)',
      borderRadius: '2px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0px',
    },
    checkedButtonLabel: {
      extend: 'buttonLabel',
      borderLeft: ' 4px solid #ab79ba',
      borderRight: '4px solid #ab79ba',
    },
    shortcutButtonLabel: {
      extend: 'buttonLabel',
      '&.loading': {
        borderColor: '#FFCD3E',
      },
    },
    callAmountLabel: {
      marginLeft: 4,
      color: '#FFFFFF',
      fontSize: '16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& .ant-statistic-content-prefix': {
        marginRight: 2,
      },
      '& .ant-statistic-content-suffix': {
        marginLeft: 2,
      },
    },
    actionButtonCommon: {
      boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.25)',
      borderRadius: 3,
      border: 'none',
      height: actionButtonHeight,
      color: theme.textColor,
      width: '100%',
      margin: [0, 5],
      fontSize: 14,
      textTransform: 'uppercase',
    },
    // TODO @@ call
    callButton: {
      boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.25)',
      borderRadius: 3,
      border: 'none',
      height: actionButtonHeight,
      color: theme.textColor,
      width: '100%',
      margin: [0, 5],
      fontSize: 14,
      textTransform: 'uppercase',
      padding: 0,
      background:
        'linear-gradient(0deg, #33DD553F, #33DD553F), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #33DD5566, #33DD5566), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
      },
      '&.callButtonLoading': {
        boxShadow:
          '0px 0px 5px 2px rgba(255, 255, 255, 0.50), 0px 0px 5px 5px rgba(51, 221, 85, 0.25)',
        background:
          'linear-gradient(0deg, #33DD5566, #33DD5566), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
    },
    callButtonLabel: {
      extend: 'buttonLabel',
      '&.callButtonLoading': {
        borderColor: '#33DD55',
        // TODO @@ bug here
        marginInlineEnd: '0px',
      },
    },
    foldButton: {
      extend: 'actionButtonCommon',
      padding: 0,
      background:
        'linear-gradient(0deg, #66666680, #66666680), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover': {
        color: theme.textColor,
        background:
          'linear-gradient(0deg, #DDDDDD40, #DDDDDD40), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      '&.ant-btn:hover, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #DDDDDD40, #DDDDDD40), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
      },
      '&.loading': {
        boxShadow:
          '0px 0px 5px 2px rgba(221, 221, 221, 0.50), 0px 0px 5px 5px rgba(102, 102, 102, 0.25), 0px 5px 10px 0px rgba(0, 0, 0, 0.25);',
      },
    },
    foldButtonLabel: {
      // * seems like a bug from ant design, letterSpacing has to be added
      extend: 'buttonLabel',
      '&.loading': {
        borderColor: '#CBCBCB',
      },
    },
    allInButton: {
      extend: 'actionButton',
      padding: 0,
    },
    shortcutButton: {
      extend: 'actionButtonCommon',
      // extend: 'actionButton',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      padding: '0px',
      background:
        'linear-gradient(0deg, #FFCD3E40, #FFCD3E40), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      margin: '5px 0 0 0',
      '&.loading': {
        // boxShadow:
        // '0px 0px 5px 2px rgba(255, 255, 255, 0.50), 0px 0px 5px 5px rgba(51, 221, 85, 0.25)',
        background:
          'linear-gradient(0deg, #FFCD3E70, #FFCD3E70), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      '&.ant-btn:hover, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #FFCD3E70, #FFCD3E70), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
      },
      '&Container': {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginLeft: 5,
        overflow: 'hidden',
        '&.hidden': {
          visibility: 'hidden',
        },
      },
      '&LeftBorder': {
        width: '4px',
        height: '100%',
        // background: '#FFCD3E',
        background: 'black',
        boxShadow: 'inset 0px 1px 2px 1px rgba(0, 0, 0, 0.3)',
        borderRadius: '2px 0px 0px 2px',
      },
      '&RightBorder': {
        width: '4px',
        height: '100%',
        // background: '#FFCD3E',
        background: 'black',
        boxShadow: 'inset 0px 1px 2px 1px rgba(0, 0, 0, 0.3)',
        borderRadius: '0px 2px 2px 0px',
      },
      '&Wrap': {
        display: 'grid',
        gridTemplateRows: '10px 1fr',
        height: 'calc( 100% - 5px )',
        marginTop: '5px',
      },
      '&Tag': {
        height: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '&BB': {
        color: 'white',
        fontSize: '10px',
        lineHeight: '10px',
      },
      '&MinMax': {
        color: 'red',
        fontSize: '12px',
        marginRight: '4px',
      },
      '&Percentage': {
        color: 'white',
        fontSize: '12px',
      },
      '&Column': {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        '& .ant-statistic-content-prefix': {
          marginRight: 0,
        },
        '& .ant-statistic-content-suffix': {
          marginLeft: 1,
        },
      },
      '&Text': {
        fontSize: '12px',
        marginRight: '4px',
      },
    },
    // * checkButton
    checkButton: {
      boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.25)',
      borderRadius: 3,
      border: 'none',
      height: actionButtonHeight,
      color: theme.textColor,
      width: '100%',
      margin: [0, 5],
      fontSize: 14,
      textTransform: 'uppercase',
      // boxShadow: '0px 0px 5px 5px #33DD5540, 0px 0px 5px 2px #FFFFFF80',
      padding: 0,
      // extend: 'actionButton',
      position: 'relative',
      '&Text': {
        paddingLeft: 12,
      },
      '&[disabled] .ant-checkbox': {
        pointerEvents: 'auto',
      },
      '& .ant-checkbox-wrapper': {
        fontSize: 0,
      },
      '& .ant-checkbox': {
        '& .ant-checkbox-inner': {
          width: 18,
          height: 18,
          backgroundColor: '#74768D',
          border: '1px solid #74768D',
        },
      },
      '& .ant-checkbox-checked': {
        '&:after': {
          border: '1px solid #74768D',
        },
        '& .ant-checkbox-inner:after': {
          transform: ' rotate(45deg) scale(1.5) translate(-50%, -50%) ',
        },
      },
      '& .visible': {
        display: 'inline-block',
      },
      background:
        'linear-gradient(0deg, #33DD553F, #33DD553F), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover': {
        background:
          'linear-gradient(0deg, #33DD5566, #33DD5566), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #33DD5566, #33DD5566), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
        '& > div': {
          borderColor: '#33DD55',
        },
      },
      '&.checkButtonLoading': {
        boxShadow:
          '0px 0px 5px 2px rgba(255, 255, 255, 0.50), 0px 0px 5px 5px rgba(51, 221, 85, 0.25)',
        background:
          'linear-gradient(0deg, #33DD5566, #33DD5566), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
    },
    checkButtonLabel: {
      extend: 'buttonLabel',
      '&.checkButtonLoading': {
        borderColor: '#33DD55',
      },
    },
    persistentActionButton: {
      extend: 'actionButton',
      width: '50%',
      padding: '0px',
      position: 'relative',
      '&Text': {
        paddingLeft: 8,
      },
      '&[disabled] .ant-checkbox': {
        pointerEvents: 'auto',
      },
      '& .ant-checkbox': {
        '& .ant-checkbox-inner': {
          width: 18,
          height: 18,
          backgroundColor: '#74768D',
          border: '1px solid #74768D',
          borderColor: '#74768D !important',
        },
      },
      '& .ant-checkbox-checked': {
        '&:after': {
          border: '1px solid #74768D',
        },
        '& .ant-checkbox-inner:after': {
          transform: ' rotate(45deg) scale(1.5) translate(-50%, -50%) ',
        },
      },
    },
    checkedPersistentButton: {
      background:
        'linear-gradient(0deg, rgba(141, 76, 171, 0.25), rgba(141, 76, 171, 0.25)), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      boxShadow: '0px 0px 5px rgb(233 147 255 / 50%), 0px 5px 10px rgb(0 0 0 / 25%)',
      '&.ant-btn:hover': {
        background:
          'linear-gradient(0deg, rgba(141, 76, 171, 0.25), rgba(141, 76, 171, 0.25)), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
    },
    // * checkOrFoldButton
    checkOrFoldButton: {
      extend: 'persistentActionButton',
      background:
        'linear-gradient(0deg, #B1393959, #B1393959), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover': {
        color: theme.textColor,
        background:
          'linear-gradient(0deg, #B1393980, #B1393980), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #B1393980, #B1393980), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
        '& > div': {
          borderColor: '#FF4848',
        },
      },
    },
    checkedCheckOrFoldButton: {
      background:
        'linear-gradient(0deg, #B1393980, #B1393980), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      boxShadow: '0px 0px 5px rgb(233 147 255 / 50%), 0px 5px 10px rgb(0 0 0 / 25%)',
      '&.ant-btn:hover': {
        background:
          'linear-gradient(0deg, #B1393980, #B1393980), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
    },
    checkedCheckOrFoldButtonLabel: {
      extend: 'buttonLabel',
      borderLeft: '4px solid #FF4848',
      borderRight: '4px solid #FF4848',
    },
    // * callAnyButton
    callAnyButton: {
      extend: 'persistentActionButton',
      background:
        'linear-gradient(0deg, #3D56B059, #3D56B059), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover': {
        color: theme.textColor,
        background:
          'linear-gradient(0deg, #3D56B080, #3D56B080), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #3D56B080, #3D56B080), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
        '& > div': {
          borderColor: '#7693FF',
        },
      },
      // TODO @@ boxShadow
      // boxShadow: '0px 5px 10px 0px rgba(0, 0, 0, 0.25), 0px 5px 10px 0px rgba(0, 0, 0, 0.25), 0px 5px 10px 0px rgba(0, 0, 0, 0.25), 0px 0px 5px 5px rgba(61, 86, 176, 0.25), 0px 0px 5px 2px rgba(255, 255, 255, 0.5)',
    },
    checkedCallAnyButton: {
      background:
        'linear-gradient(0deg, #3D56B080, #3D56B080), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      // TODO @@ boxShadow
      // boxShadow: '0px 0px 5px rgb(233 147 255 / 50%), 0px 5px 10px rgb(0 0 0 / 25%)',
      '&.ant-btn:hover': {
        background:
          'linear-gradient(0deg, #3D56B080, #3D56B080), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      // TODO @@ boxShadow
      // boxShadow:
      //   '0px 5px 10px 0px rgba(0, 0, 0, 0.25), 0px 5px 10px 0px rgba(0, 0, 0, 0.25), 0px 5px 10px 0px rgba(0, 0, 0, 0.25), 0px 0px 5px 5px rgba(61, 86, 176, 0.25), 0px 0px 5px 2px rgba(255, 255, 255, 0.5)',
    },
    checkedCallAnyButtonLabel: {
      extend: 'buttonLabel',
      borderLeft: '4px solid #7693FF',
      borderRight: '4px solid #7693FF',
    },
    // * waitForBlindButton
    waitForBlindButton: {
      extend: 'persistentActionButton',
      background:
        'linear-gradient(0deg, #00ADFB1A, #00ADFB1A), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover': {
        color: theme.textColor,
        background:
          'linear-gradient(0deg, #00ADFB1A, #00ADFB1A), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #00ADFB1A, #00ADFB1A), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
        '& > div': {
          borderColor: 'black',
        },
      },
    },
    checkedWaitForBlindButton: {
      background:
        'linear-gradient(0deg, #00ADFB66, #00ADFB66), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover': {
        color: theme.textColor,
        background:
          'linear-gradient(0deg, #00ADFB66, #00ADFB66), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #00ADFB66, #00ADFB66), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
        '& > div': {
          borderColor: '#00ADFB',
        },
      },
    },
    waitForBlindButtonLabel: {
      extend: 'buttonLabel',
      borderLeft: '4px solid #0C1015',
      borderRight: '4px solid #0C1015',
    },
    checkedWaitForBlindLabel: {
      extend: 'buttonLabel',
      borderLeft: '4px solid #00ADFB',
      borderRight: '4px solid #00ADFB',
    },
    // * joinDirectlyButton
    joinDirectlyButton: {
      extend: 'persistentActionButton',
      background:
        'linear-gradient(0deg, #4AB17240, #4AB17240), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover': {
        color: theme.textColor,
        background:
          'linear-gradient(0deg, #4AB17240, #4AB17240), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #4AB17240, #4AB17240), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
        '& > div': {
          borderColor: 'black',
        },
      },
    },
    checkedJoinDirectlyButton: {
      background:
        'linear-gradient(0deg, #33DD5566, #33DD5566), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      '&.ant-btn:hover': {
        color: theme.textColor,
        background:
          'linear-gradient(0deg, #33DD5566, #33DD5566), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, #33DD5566, #33DD5566), linear-gradient(360deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
        color: 'white',
        '& > div': {
          borderColor: '#33DD55',
        },
      },
    },
    joinDirectlyButtonLabel: {
      extend: 'buttonLabel',
      borderLeft: '4px solid black',
      borderRight: '4px solid black',
    },
    checkedJoinDirectlyButtonLabel: {
      extend: 'buttonLabel',
      borderLeft: '4px solid #33DD55',
      borderRight: '4px solid #33DD55',
    },
    raiseButton: {
      extend: 'actionButton',
    },
    switchButtonTypeButton: {
      width: 15,
      height: actionButtonHeight,
      padding: 0,
      background: 'rgb(34, 34, 34)',
      color: theme.textColor,
      border: 'none',
      '&:focus, &:active': {
        background: 'rgb(34, 34, 34)',
        color: theme.textColor,
      },
    },
    hidden: {
      display: 'none',
    },
    '@keyframes slideUp': {
      '0%': {
        transform: 'translateY(100%) scaleY(0.1)',
        opacity: 0,
      },
      '100%': {
        transform: 'translateY(0) scaleY(1)',
        opacity: 1,
      },
    },
    slideUp: {
      animation: '$slideUp 0.75s ease-out forwards',
    },
    buttonsRowScrollableContainer: {
      extend: 'buttonsRow',
      position: 'relative',
      display: 'block',
      // TODO double check if this is needed
      // overflow: 'auto',
      margin: [0, 10, 10, 10],
    },
    buttonsRowScrollableLongDiv: {
      width: '100%',
      display: 'flex',
    },
    buttonsRowScrollable: {
      extend: 'buttonsRow',
      alignItems: 'flex-end',
      width: '100%',
      marginTop: 0,
      padding: 0,
      flexBasis: '100%',
      justifyContent: 'space-between',
      '& .ant-btn[disabled]': {
        // display: 'none',
      },
      '& button:nth-child(1)': {
        margin: '0 5px 0 0',
      },
    },
    waitForBlindButtonContainer: {
      animation: '$slideUp 0.75s ease-out forwards',
      extend: 'buttonsRow',
      justifyContent: 'flex-start',
      padding: '10px 5px',
    },
    buttonsRowAllinScrollable: {
      extend: 'buttonsRowScrollable',
    },
    fadeOut: {
      // display:'none'
    },
    persistentButtonRow: {
      animation: '$slideUp 0.75s ease-out forwards',
      extend: 'buttonsRowScrollable',
      '& button:first-of-type': {
        margin: '0 5px 0 0',
      },
      '& button:last-of-type': {
        margin: '0 0 0 5px',
      },
      '& .ant-btn:hover': {},
    },
    buttonsRow: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexFlow: 'row nowrap',
      background: 'transparent',
      '& .ant-btn:hover': {},
      '& .ant-btn[disabled]': {
        // visibility: 'hidden',
      },
    },
    playerComponentInsuraceCase: {
      position: 'absolute',
      bottom: '60px',
    },
    playerComponentDiv: {
      position: 'absolute',
      bottom: '60px',
      display: 'flex',
      justifyContent: 'space-between',
      width: 'auto',
    },
    sliderNumpadDiv: {
      extend: 'playerComponentDiv',
      bottom: 35 + 24, // Safety area bottom
      width: 'auto',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1,
    },
    actionButtonHidden: {
      display: 'none',
    },
    buttonRowHidden: {
      display: 'none',
    },
    gifHidden: {
      opacity: 0.0001,
      transform: 'translateY(100%)',
    },
    hiddenButOccupySpace: {
      visibility: 'hidden',
    },
    numpadMask: {
      opacity: '0',
      position: 'fixed',
      width: '100%',
      height: '100%',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1,
    },
    sliderMask: {
      extend: 'numpadMask',
      zIndex: 1,
    },
    numpadContainer: {
      position: 'absolute',
      left: '90%',
      transform: 'translatex(-50%)',
      bottom: '30%',
      width: 210,
      height: 270,
      zIndex: ACTION_BUTTON_Z_INDEX.NUMPAD,
      background: 'rgba(44, 44, 49, 0.9)',
      borderRadius: 5,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      boxShadow: 'inset 0px 0px 5px rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(5px)',
    },
    buttonRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
    },
    numpadRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    numpadDisplayRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: 190,
      background: '#000000',
      boxShadow: 'inset 0px 0px 5px 5px rgba(0, 0, 0, 0.1);',
      opacity: '0.85',
      borderRadius: '5px',
      margin: '5px 12.5px 5px 12.5px',
      height: 40,
      padding: '4px 8px',
    },
    dollarSign: {
      color: 'white',
      fontSize: '23px',
      fontWeight: 600,
    },
    redWarning: {
      color: 'red',
    },
    numpadDisplayField: {
      '&.ant-statistic': {
        fontWeight: 600,
      },
      display: 'flex',
      alignItems: 'center',
    },
    numpadTheme: {
      background: 'transparent',
      opacity: '0.9',
      borderRadius: '0 0 3px 3px ',
      padding: '5px 12.5px 30px 12.5px',
    },
    buttonTheme: {
      '&.hg-button.hg-standardBtn, &.hg-button.hg-functionBtn': {
        color: 'white',
        backgroundColor: 'rgb(16 16 16 / 90%)',
        height: 40,
        width: 60,
        borderRadius: '3px',
        borderBottom: 'none',
        fontSize: '20px',
        fontWeight: '600',
        '&:hover': {
          background: 'radial-gradient(#6a6a6a, #191919)',
          // transform: 'scale(1.2)',
          // transition: 'transform .25s',
        },
        '&.hg-button-bksp': {
          '&:after': {
            content: 'url(/icon/backspace-icon.svg)',
          },
        },
      },
    },
    gameResultIMG: {
      marginTop: '10px',
      height: '120px',
      width: '150px',
      objectFit: 'contain',
    },
    modalTitle: {
      display: 'block',
      fontSize: '16px',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    mySlider: {
      height: 145,
      width: 40,
      borderRadius: '10px',
      border: '2px solid #FBE37D',
      background:
        'linear-gradient(180deg, rgba(255, 199, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 16.67%, rgba(9, 9, 9, 0.25) 33.33%, rgba(0, 0, 0, 0.25) 50%, rgba(0, 0, 0, 0.25) 66.67%, rgba(0, 0, 0, 0.25) 83.33%, rgba(0, 0, 0, 0.25) 100%)',
      boxShadow: '0px 0px 5px 0px #000, 0px 0px 10px 0px #000 inset',
      backdropFilter: 'blur(10px)',
    },
    sliderContainer: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      // bottom: '35px',
      bottom: 17.5,
      zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_CONTAINER,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      animation: `$bounceUp 1s ease-out`,
      '& .ant-form-item': {
        margin: 0,
      },
      '&.hidden': {
        // * visibility would affect animation, please avoid
        // visibility: 'hidden',
        display: 'none',
      },
    },
    myThumb: {
      color: 'white',
      left: '-50%',
      transform: 'translateX(25%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background:
        'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(352.35deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      height: 38,
      width: 50,
      borderRadius: '10px',
      border: '2px #D8BA5D solid',
      filter:
        'drop-shadow(0px 0px 1.5px #FFFFFF) drop-shadow(0px 0px 2.5px rgba(255, 255, 255, 0.5))',
      textShadow: '1px 2px 1px #26052C',
      fontSize: 12,
      fontWeight: 800,
    },
    allInLabel: {
      position: 'relative',
      // zIndex: ACTION_BUTTON_Z_INDEX.ALL_IN_LABEL,
      zIndex: 0,
      // marginBottom: '-10px',
      // marginBottom: 3,
      textAlign: 'center',
    },
    allInImage: {
      marginBottom: '-15px',
      height: 30,
    },
    allInValue: {
      '& .ant-statistic-content-prefix': {
        marginRight: 0,
      },
    },
    minBetValue: {
      position: 'relative',
      top: -30,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: -1,
      '& .ant-statistic-content-prefix': {
        marginRight: 0,
      },
    },
    // myTrack: {
    //   height: 200,
    //   width: '40',
    //   border: '2px #FBE37D solid',
    // },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
